module.exports = {"name":"@atlaskit/datetime-picker","version":"6.0.2"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/datetime-picker/dist/package.json
// module id = 288
// module chunks = 0